import { TenantTranslate } from './tenantTranslate.model';

const TenantTranslatePTBR: TenantTranslate = {
  create: {
    title: 'Adicionar uma nova organização',
    fields: {
      name: 'Nome da organização',
    },
    errors: {
      name: {
        required: 'O nome da organização é obrigatório',
        invalid: 'O nome da organização deve conter no mínimo 3 caracteres',
      },
      conflict: 'O nome da organização já existe',
    },
    button: {
      create: 'Criar',
    },
    success: 'Organização criada com sucesso',
  },
  choose: {
    title: 'Selecione uma organização',
  },
};

export default TenantTranslatePTBR;
